import { Box, BoxProps } from "@twilio-paste/core/box";
import React from "react";

export const SidebarItem: React.FC<BoxProps> = (props) => (
    <Box
        as="li"
        margin="space20"
        fontSize={["fontSize50", "fontSize50", "fontSize30"]}
        lineHeight="lineHeight20"
        {...props}
    />
);
